module.exports = __webpack_public_path__ + "img/camera.379a2ba3.png";